import React from 'react';
import SessionStorage from '../../../api/session-storage';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import {
  receivedLogout,
  receivedLogUserIn,
  saveLoggedUser,
} from '../../../store/actions/user-actions';
import { setHeaderModal } from '../../../store/actions/header-actions';
import Modal from '../../components/modal/modal';
import PopupTwoButtons from '../../components/popup/popup-two-buttons';
import { selectKey } from '../../../utilities/helper';
import './header.scss';
import { cancelSpeech } from '../../../utilities/helper';

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { receivedLogUserIn, setHeaderModal, saveLoggedUser, receivedLogout },
    dispatch,
  );
};

class Header extends React.Component {
  constructor() {
    super();
    this.state = {
      modalIsOpen: false,
      modalIndex: 0,
    };
  }

  closeModal = () => {
    const { setHeaderModal } = this.props;
    setHeaderModal(false);
    this.setState({ modalIndex: 0 });
    setTimeout(() => {
      document.getElementById('logout').focus();
    }, 200);
  };

  openModal = async () => {
    const { setHeaderModal } = this.props;
    setHeaderModal(true);
    if (window.speechSynthesis.speaking) {
      window.speechSynthesis.pause();
    }
  };

  onKeyPress = event => {
    const isModalOpen = this.props.headerStore.isModalOpen;
    if (event.key === 'Enter' && !isModalOpen) {
      this.openModal();
      document.getElementById('logout').blur();
    }
  };

  logOut = async () => {
    await cancelSpeech();
    const { receivedLogUserIn, setHeaderModal, receivedLogout } = this.props;
    setHeaderModal(false);
    const user = SessionStorage.getUser();
    if (user.delivery_type.toLowerCase() === 'remote') {
      this.props.history.push('/remote/login');
    }
    if (user.delivery_type.toLowerCase() === 'center') {
      this.props.history.push('/center/login');
    }
    receivedLogUserIn(false);
    receivedLogout(true);
    SessionStorage.clearStorage();
  };

  setModalIndex = index => {
    this.setState({ modalIndex: index });
  };

  modalNavigation = event => {
    const ids = ['button-primary-modal', 'button-secondary-modal'];
    const focusedElement = document.activeElement.id;
    const arrows = ['ArrowDown', 'ArrowUp'];
    if (this.state.modalIndex <= ids.length - 1 && this.state.modalIndex >= 0) {
      selectKey(
        event,
        this.state.modalIndex,
        ids,
        focusedElement,
        this.setModalIndex,
        arrows,
      );
    }
  };

  render() {
    const isUserLogged = this.props.userStore.isLogged;
    const userInfo = this.props.userStore;
    const isModalOpen = this.props.headerStore.isModalOpen;
    const image = `data:image;base64, ${userInfo.user.photo}`;
    return (
      <div className="header-container" id="header-container">
        <header className="header">
          <div className="header-slope-background">
            <div className="header-logo" tabIndex={-1}>
              <img
                src="/images/Logo.png"
                alt="A C T Logo"
                id="act-logo"
                aria-hidden="true"
              />
            </div>
          </div>
          <div className="header-straight-background">
            {isUserLogged && (
              <div className="header-user-info">
                <div className="user-info" aria-label="Examinee information">
                  <p className="user-name" id="user-name">
                    {this.props.userStore.user.name}
                  </p>
                  <p className="user-room" id="user-room">
                    Room Code
                  </p>
                  <p className="user-code" id="user-code">
                    {userInfo.room}
                  </p>
                </div>
                <div className="user-image">
                  <img
                    src={image}
                    alt="User image"
                    id="user-image"
                    aria-hidden="true"
                  />
                  <div
                    className="logout"
                    id="logout"
                    onClick={this.openModal}
                    onKeyUp={this.onKeyPress}
                    tabIndex="0"
                    aria-label="log out"
                    role="button"
                  >
                    <img
                      src="/images/logout.png"
                      alt="Logout button"
                      aria-hidden="true"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </header>
        <div className="header-bar">
          <div className="header-bar-slope"></div>
          <div className="header-bar-straight"></div>
        </div>
        <Modal
          isOpen={isModalOpen}
          closeModal={this.closeModal}
          className={'modal-content two-buttons'}
          ariaProps={{
            modal: true,
          }}
          child={
            <PopupTwoButtons
              title="Logout"
              description="Are you sure you want to logout?"
              button1Text="Logout"
              button2Text="Cancel"
              padding="0 75px"
              onClickBtn1={this.logOut}
              onClickBtn2={this.closeModal}
              onKeyUp={this.modalNavigation}
            />
          }
        />
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
